import { useState } from "react";
import { isValidEmail } from "../../../lib/validateEmail";
import { useUserService } from "../../../hooks/useUserService";
import { htmlBody } from "../../../lib/htmlBody";
import key from "../../../key";

import { Layout } from "../Layout";

import styles from "@/styles/send-email.module.css";

export const SendEmail = () => {
    const [email, setEmail] = useState<string>("");
    const [message, setMessage] = useState<string>("");

    const service = useUserService();

    const handlerChangeEmail = (e: any) => {
        const value = e.target.value;
        setEmail(value);
    };

    const handlerSubmitEmail = async () => {
        if (!email) {
            return alert("Estes campos são obrigatórios!");
        }

        if (!isValidEmail(email)) {
            return alert("O endereço de e-mail fornecido não parece válido. o formato padrão (exemplo@dominio.com).");
        }

        try {
            const users = await service.findByEmail(email);

            if (!users || users.length === 0) {
                return alert("O usuário informado não existe. Verifique os dados e tente novamente.");
            }

            const response = users[0];

            if (!response) {
                return alert("O usuário informado não existe. Verifique os dados e tente novamente.");
            }

            const user = await service.findUser(response.CPFCNPJ);

            if (!user) {
                return alert("O usuário informado não existe. Verifique os dados e tente novamente.");
            }

            const ssid = user?.SENHA.slice(0, 10);
            const url = `${key.appDomainUrl}/forgout?send=true&ssid=${ssid}`;
            const image = `${key.appDomainUrl}/artesanato_logo.png`;
            const to = email;
            const subject = "Aplicativo Arteão - Recuperação de Senha";
            const html = htmlBody(url, image);

            await service.emailCheck(to, subject, html);

            setMessage(`
                As instruções para redefinir a senha serão enviadas para o e-mail que você
                forneceu, caso ele esteja cadastrado em sua conta.
            `);
        } catch (error) {
            setMessage("");
            console.log(error);
        }
    };

    return (
        <Layout
            title="Alterar Senha - (Artesanato PE)"
            description="Este é o background da página inicial"
            transition="/videos/bkg-page.mp4"
            subscription="">
            <div className="page-container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3"></div>

                        <div className="col-md-6">
                            <h1 className="form-label">Redefinir senha</h1>
                            <p className="form-info">Enviaremos instruções por e-mail sobre como redefinir sua senha.</p>
                            {message && <div className="message-response"><small>{message}</small></div>}

                            <div className="input-group-container">
                                <label htmlFor="email">Email</label>
                                <div className="input-group-content">
                                    <input type="text"
                                        className="input-style"
                                        onChange={handlerChangeEmail} />
                                    <span className="material-symbols-outlined icon-input">edit</span>
                                </div>
                            </div>

                            <div className="button-group-container" onClick={handlerSubmitEmail}>
                                <span className="material-symbols-outlined icon-button">send</span>
                                <div className="button-submit">Verificar email</div>
                            </div>
                        </div>

                        <div className="col-md-3"></div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};